import { render, staticRenderFns } from "./travel-application-details.vue?vue&type=template&id=794bab75&"
import script from "./travel-application-details.vue?vue&type=script&lang=js&"
export * from "./travel-application-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports